import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUpdateSettings = () => {
  return useMutation({
    mutationFn: (data) => api.settings.updateSwitch(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить настройки деактивации модулей',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Настройки успешно сохранены',
        type: 'success',
      })
    }
  })
}
